import { db } from './firebase';
import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore'; 

//import { useHistory } from "react-router-dom";

const Commandform = () => {




//const history = useHistory();
const [name,setname] = useState('');
const [phone,setphone] = useState('');
const [email,setemail] = useState('');
const [phone2,setphone2] = useState('');
const [adresse,setadresse] = useState('');
const [quantite,setquantite] = useState('1');
 
const handleSubmit = async (e) => {
    e.preventDefault();
    const command = { name, phone, phone2,email ,adresse,quantite };
console.log(command);
try {
    const docRef = await addDoc(collection(db, "commands"), command);
    console.log("Document written with ID: ", docRef.id);
    window.location.reload();
  } catch (e) {
    console.error("Error adding document: ", e);
  }

   
  }



    return ( 
        <div className="commandform">
          <br />
            <h3>confirme your commande</h3>
            <form onSubmit={handleSubmit}>
                <label htmlFor="">Full name</label>
                <input  type="text" required value={name} onChange={(e) => setname(e.target.value)}  />
                <label htmlFor="">Phone number</label>
                <input type="text" required value={phone} onChange={(e) => setphone(e.target.value)} />
                <label htmlFor="">second phone number</label>
                <input type="text" value={phone2} onChange={(e) => setphone2(e.target.value)} />
                <label htmlFor="">email</label>
                <input type="email" required value={email} onChange={(e) => setemail(e.target.value)} />
                <label htmlFor="">adresse</label>
                <input type="text" required value={adresse} onChange={(e) => setadresse(e.target.value)} />
                <label htmlFor="">quantite</label>
                <input type="number" min={1} required value={quantite} onChange={(e) => setquantite(e.target.value)} />
                <button>Confirme Commande</button>
            </form>
        </div>
     );
}
 
export default Commandform;